import React, { useContext } from "react";
import { CFormSwitch } from '@coreui/react'
import { DashboardContext } from "src/contexts/DashboardContext";
import styles from './PickUpPointSwitch.module.css'

export default function PickUpPointSwitch(props) {
  const {addLocalApiBody, setAddLocalApiBody} = useContext(DashboardContext);
  
  const handleSwitch = (e) => {
    setAddLocalApiBody({
        ...addLocalApiBody, 
        is_pick_up_point: e.target.checked
      })
  }

  return (
    <CFormSwitch
        size="xl"
        label="Quiero que mi local sea un punto de recogida"
        id="pickUpPointSwitch"
        className={styles.switch}
        defaultChecked={addLocalApiBody?.is_pick_up_point}
        onChange={(e) => handleSwitch(e)}
      />
  );
}
